import axios from "axios"

export function sendNotification(msg) {
  axios
    .post("https://sparkle.ng/sparkle-vas/send-notification", msg)
    .then((res) => {
      console.log(res)
    })
    .catch((error) => {
      console.error("this is the error", error)
    })
}

export function notifyUser(msg) {
  axios
    .post("https://sparkle.ng/sparkle-vas/send-notification", msg)
    .then((res) => {
      console.log(res)
    })
    .catch((error) => {
      console.error("this is the error", error)
    })
}

export const getBusinessNature = () => {
  return axios.get(`${process.env.DIY_BASE_URL}/api/options/v1/BusinessNatures`)
}
export const getCountries = () => {
  return axios.get(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`)
}
export const getState =  () => {
  return axios.get('https://apigateway.sparkleapp.in/api/v1/kyc/states')
}
export const getIdentityTypes = () => {
  return axios.get(`${process.env.DIY_BASE_URL}/api/options/v1/IdentityTypes`)
}


 
